import {Button, ButtonGroup, closeCurrentDialog, IconButton} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

export function CampaignPublishingDeleteContent() {
  return (
    <>
      <VStack align="flex-end">
        <IconButton
          data-testid="campaignPublishingDeleteContent-close"
          icon="navigation/close"
          onClick={closeCurrentDialog}
        />
      </VStack>
      <VStack spacing={1}>
        <Text>{i18n.t('entity.salesCampaign.deleteDialog.description')}</Text>
      </VStack>
      <ButtonGroup align="right">
        <Button
          data-testid="campaignPublishingDeleteContent-confirm"
          variant="primary"
          onClick={closeCurrentDialog}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </>
  );
}
